// extracted by mini-css-extract-plugin
export var projectTechstack = "ProjectTechstack-module--projectTechstack--3D6PG";
export var title = "ProjectTechstack-module--title--1eEvg {ProjectsYaml-slug}-module--metatitle--SC1_R";